import { render, staticRenderFns } from "./AddBatchPaymentBreakdown.vue?vue&type=template&id=23d6d4f6"
import script from "./AddBatchPaymentBreakdown.vue?vue&type=script&lang=js"
export * from "./AddBatchPaymentBreakdown.vue?vue&type=script&lang=js"
import style0 from "./AddBatchPaymentBreakdown.vue?vue&type=style&index=0&id=23d6d4f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports